import styled from 'styled-components'

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  background-color: #fff;
  overflow: hidden;
`

export const Header = styled.div`
  padding: 16px 24px 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

export const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  color: #ffffff;
`

export const Body = styled.div`
  display: flex;
  gap: 40px;
  padding: 24px 24px 40px;
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  background: #ffffff;
`

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 50%;
  padding-bottom: 8px;
`

export const FirstRow = styled.div`
  display: flex;
  gap: 80px;
`

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px 0px 10px;
  gap: 16px;
`

export const PvTableChartRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
  flex-wrap: wrap;
`

export const PvTableBox = styled.div`
  flex: 0 0 auto;
  max-width: 100%;
  overflow-x: auto;
`

export const PvChartBox = styled.div`
  flex: 1 1 360px;
  min-width: 320px;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;

  @media (max-width: 1280px) {
    flex-basis: 100%;
  }
`

export const GraphWrapper = styled.div`
  height: 100%;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  gap: 12px;
`

export const GraphBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`

export const SinglePriceBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  background: #f9fafb;
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  color: #373a40;
`

export const PlanSummaryText = styled.div`
  font-family: SUIT;
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  color: #373a40;
`

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid transparent;
`

export const TableRow = styled.div`
  display: flex;
`

interface TableGrayProps {
  white?: boolean
}

export const TableCell = styled.div<TableGrayProps>`
  display: flex;

  width: 149.2px;
  height: 38px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const TableCell2 = styled.div<TableGrayProps>`
  display: flex;

  width: 149.2px;
  height: 30.77px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const TableCell3 = styled.div<TableGrayProps>`
  display: flex;

  width: 186.5px;
  height: 30.77px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

export const Right = styled.div`
  display: flex;
  width: 50%;
  flex-direction: column;
  gap: 32px;
  padding-bottom: 8px;
`
